import { render, staticRenderFns } from "./danciP.vue?vue&type=template&id=3cd38a02&scoped=true"
import script from "./danciP.vue?vue&type=script&lang=js"
export * from "./danciP.vue?vue&type=script&lang=js"
import style0 from "./danciP.vue?vue&type=style&index=0&id=3cd38a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd38a02",
  null
  
)

export default component.exports